import { ApiClient } from '@/lib/axios/client';

export interface ChatbotTaskRow {
  task_name: string;
  description?: string;
  type?: string;
  data?: string;
  group?: string;
  mutable?: boolean;
  mask_output?: boolean;
  tags?: { key: string; value: string }[];
}

export interface BulkTaskError {
  row_number?: number;
  message?: string;
}

export interface ParseChatbotTasksResponse {
  tasks?: ChatbotTaskRow[];
  errors?: BulkTaskError[];
}

export class ChatbotTaskImportApi {
  static async getTemplate(): Promise<Blob> {
    return await ApiClient.get<Blob>('/api/v1/chatbots/tasks/template', { responseType: 'blob' });
  }

  static async parseTasks(file: File): Promise<ParseChatbotTasksResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return await ApiClient.post<ParseChatbotTasksResponse>(
      '/api/v1/chatbots/tasks/parse',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  static async exportTasks(tasks: ChatbotTaskRow[]): Promise<Blob> {
    return await ApiClient.post<Blob>(
      '/api/v1/chatbots/tasks/export',
      { tasks },
      { responseType: 'blob' }
    );
  }
}
